import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faTimes, faUtensils, faImages, faUpload } from '@fortawesome/free-solid-svg-icons';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import baseURL from '../../url';
import '../AdminCommon.css';
import './NewProduct.css';

export default function NewProduct({ onProductCreated }) {
    const [modalOpen, setModalOpen] = useState(false);
    const [cargando, setCargando] = useState(false);
    const [categorias, setCategorias] = useState([]);
    const [tabActiva, setTabActiva] = useState('datos');

    // Campos de texto
    const [titulo, setTitulo] = useState('');
    const [descripcion, setDescripcion] = useState('');
    const [categoria, setCategoria] = useState('');
    const [masVendido, setMasVendido] = useState('no');
    const [precio, setPrecio] = useState('');
    const [precioAnterior, setPrecioAnterior] = useState('');

    // Items opcionales
    const [item1, setItem1] = useState('');
    const [item2, setItem2] = useState('');
    const [item3, setItem3] = useState('');
    const [item4, setItem4] = useState('');
    const [item5, setItem5] = useState('');
    const [item6, setItem6] = useState('');
    const [item7, setItem7] = useState('');
    const [item8, setItem8] = useState('');
    const [item9, setItem9] = useState('');
    const [item10, setItem10] = useState('');

    // Imágenes y vistas previas
    const [fileImg1, setFileImg1] = useState(null);
    const [fileImg2, setFileImg2] = useState(null);
    const [fileImg3, setFileImg3] = useState(null);
    const [fileImg4, setFileImg4] = useState(null);

    const [prev1, setPrev1] = useState(null);
    const [prev2, setPrev2] = useState(null);
    const [prev3, setPrev3] = useState(null);
    const [prev4, setPrev4] = useState(null);

    useEffect(() => {
        cargarCategorias();
    }, []);

    const cargarCategorias = () => {
        fetch(`${baseURL}/categoriasGet.php`)
            .then(res => res.json())
            .then(data => setCategorias(data.categorias || []))
            .catch(err => console.error('Error al cargar categorías:', err));
    };

    const handleFileChange = (e, num) => {
        const file = e.target.files[0];
        if (!file) return;
        const previewUrl = URL.createObjectURL(file);
        if (num === 1) { setFileImg1(file); setPrev1(previewUrl); }
        if (num === 2) { setFileImg2(file); setPrev2(previewUrl); }
        if (num === 3) { setFileImg3(file); setPrev3(previewUrl); }
        if (num === 4) { setFileImg4(file); setPrev4(previewUrl); }
    };

    const resetForm = () => {
        setTitulo('');
        setDescripcion('');
        setCategoria('');
        setMasVendido('no');
        setPrecio('');
        setPrecioAnterior('');
        setItem1('');
        setItem2('');
        setItem3('');
        setItem4('');
        setItem5('');
        setItem6('');
        setItem7('');
        setItem8('');
        setItem9('');
        setItem10('');
        setFileImg1(null);
        setFileImg2(null);
        setFileImg3(null);
        setFileImg4(null);
        setPrev1(null);
        setPrev2(null);
        setPrev3(null);
        setPrev4(null);
        setTabActiva('datos');
    };

    const toggleModal = () => {
        if (modalOpen) {
            resetForm();
        }
        setModalOpen(!modalOpen);
    };

    const crear = async (e) => {
        if (e) e.preventDefault();

        if (!titulo.trim()) {
            toast.warn('Ingresa el título del producto.');
            return;
        }
        if (!precio || parseFloat(precio) < 0) {
            toast.warn('Ingresa un precio válido para el producto.');
            return;
        }
        if (!categoria) {
            toast.warn('Selecciona una categoría.');
            return;
        }

        const formData = new FormData();
        formData.append('titulo', titulo.trim());
        formData.append('idCategoria', categoria);
        formData.append('masVendido', masVendido);
        formData.append('precio', precio);
        formData.append('precioAnterior', precioAnterior || 0);
        formData.append('descripcion', descripcion);
        formData.append('item1', item1);
        formData.append('item2', item2);
        formData.append('item3', item3);
        formData.append('item4', item4);
        formData.append('item5', item5);
        formData.append('item6', item6);
        formData.append('item7', item7);
        formData.append('item8', item8);
        formData.append('item9', item9);
        formData.append('item10', item10);

        if (fileImg1) formData.append('imagen1', fileImg1);
        if (fileImg2) formData.append('imagen2', fileImg2);
        if (fileImg3) formData.append('imagen3', fileImg3);
        if (fileImg4) formData.append('imagen4', fileImg4);

        setCargando(true);
        try {
            const res = await fetch(`${baseURL}/productosPost.php`, {
                method: 'POST',
                body: formData
            });
            const data = await res.json();

            if (data.mensaje) {
                toast.success(data.mensaje);
                resetForm();
                setModalOpen(false);
                if (typeof onProductCreated === 'function') {
                    onProductCreated();
                } else {
                    window.location.reload();
                }
            } else if (data.error) {
                toast.error(data.error);
            }
        } catch (error) {
            console.error('Error al crear producto:', error);
            toast.error('Error de conexión al registrar producto');
        } finally {
            setCargando(false);
        }
    };

    return (
        <div>
            <button onClick={toggleModal} className="adminBtnPrimary" title="Registrar un nuevo producto">
                <FontAwesomeIcon icon={faPlus} /> Agregar producto
            </button>

            {modalOpen && (
                <div className="adminModalOverlay" onClick={toggleModal}>
                    <div className="adminModalContent modalEditProduct" onClick={(e) => e.stopPropagation()}>
                        {/* Cabecera del Modal con Pestañas */}
                        <div className="adminModalHeader">
                            <div className="modalProductTabs">
                                <button 
                                    type="button"
                                    className={`modalTabBtn ${tabActiva === 'datos' ? 'active' : ''}`}
                                    onClick={() => setTabActiva('datos')}
                                >
                                    <FontAwesomeIcon icon={faUtensils} /> Datos del Producto
                                </button>
                                <button 
                                    type="button"
                                    className={`modalTabBtn ${tabActiva === 'fotos' ? 'active' : ''}`}
                                    onClick={() => setTabActiva('fotos')}
                                >
                                    <FontAwesomeIcon icon={faImages} /> Fotos del Producto
                                </button>
                            </div>
                            <button type="button" className="adminModalClose" onClick={toggleModal}>
                                <FontAwesomeIcon icon={faTimes} />
                            </button>
                        </div>

                        {/* Cuerpo del Modal */}
                        <div className="adminModalBody">
                            {tabActiva === 'datos' ? (
                                <div className="productEditForm">
                                    <div className="formRowGrid2">
                                        <div className="adminFormField">
                                            <label>Título / Nombre del Plato (Obligatorio):</label>
                                            <input
                                                type="text"
                                                placeholder="Ej: Hamburguesa Suprema, Pizza Especial..."
                                                value={titulo}
                                                onChange={(e) => setTitulo(e.target.value)}
                                                required
                                            />
                                        </div>

                                        <div className="adminFormField">
                                            <label>Categoría (Obligatorio):</label>
                                            <select
                                                value={categoria}
                                                onChange={(e) => setCategoria(e.target.value)}
                                                required
                                            >
                                                <option value="">Selecciona una categoría</option>
                                                {categorias.map(item => (
                                                    <option key={item.idCategoria} value={item.idCategoria}>
                                                        {item.categoria}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>

                                    <div className="formRowGrid3">
                                        <div className="adminFormField">
                                            <label>Precio de Venta (Obligatorio):</label>
                                            <input
                                                type="number"
                                                step="0.01"
                                                min="0"
                                                placeholder="0.00"
                                                value={precio}
                                                onChange={(e) => setPrecio(e.target.value)}
                                                required
                                            />
                                        </div>

                                        <div className="adminFormField">
                                            <label>Precio Anterior (Opcional):</label>
                                            <input
                                                type="number"
                                                step="0.01"
                                                min="0"
                                                placeholder="0.00"
                                                value={precioAnterior}
                                                onChange={(e) => setPrecioAnterior(e.target.value)}
                                            />
                                        </div>

                                        <div className="adminFormField">
                                            <label>¿Destacado / Más Vendido?</label>
                                            <select
                                                value={masVendido}
                                                onChange={(e) => setMasVendido(e.target.value)}
                                            >
                                                <option value="no">No</option>
                                                <option value="si">Sí (Destacado)</option>
                                            </select>
                                        </div>
                                    </div>

                                    <div className="adminFormField">
                                        <label>Descripción / Ingredientes:</label>
                                        <textarea
                                            rows="3"
                                            placeholder="Detalle de los ingredientes, porciones o preparación..."
                                            value={descripcion}
                                            onChange={(e) => setDescripcion(e.target.value)}
                                        />
                                    </div>

                                    {/* Opciones Adicionales / Variantes */}
                                    <div className="productItemsAccordion">
                                        <label className="itemsTitleLabel">Opciones Adicionales / Acompañamientos (Opcionales):</label>
                                        <div className="itemsInputsGrid">
                                            <input type="text" placeholder="Opción 1" value={item1} onChange={e => setItem1(e.target.value)} />
                                            <input type="text" placeholder="Opción 2" value={item2} onChange={e => setItem2(e.target.value)} />
                                            <input type="text" placeholder="Opción 3" value={item3} onChange={e => setItem3(e.target.value)} />
                                            <input type="text" placeholder="Opción 4" value={item4} onChange={e => setItem4(e.target.value)} />
                                            <input type="text" placeholder="Opción 5" value={item5} onChange={e => setItem5(e.target.value)} />
                                            <input type="text" placeholder="Opción 6" value={item6} onChange={e => setItem6(e.target.value)} />
                                        </div>
                                    </div>
                                </div>
                            ) : (
                                <div className="productImagesManager">
                                    <p style={{ margin: '0 0 1rem 0', fontSize: '13px', color: '#64748b' }}>
                                        Selecciona las imágenes para este producto. Puedes subir hasta 4 fotos (la Foto 1 es la principal).
                                    </p>
                                    <div className="imagesGridManager">
                                        {[1, 2, 3, 4].map(num => {
                                            const prev = num === 1 ? prev1 : num === 2 ? prev2 : num === 3 ? prev3 : prev4;
                                            return (
                                                <div key={num} className="imageUploadCard">
                                                    <span className="imageSlotLabel">Foto {num} {num === 1 ? '(Principal)' : ''}</span>
                                                    <div className="imageSlotPreview">
                                                        {prev ? (
                                                            <img src={prev} alt={`Foto ${num}`} />
                                                        ) : (
                                                            <div className="emptyImageSlot">
                                                                <FontAwesomeIcon icon={faImages} />
                                                                <span>Sin foto</span>
                                                            </div>
                                                        )}
                                                    </div>
                                                    <label className="btnSelectFile">
                                                        <FontAwesomeIcon icon={faUpload} /> Seleccionar
                                                        <input
                                                            type="file"
                                                            accept="image/*"
                                                            style={{ display: 'none' }}
                                                            onChange={(e) => handleFileChange(e, num)}
                                                        />
                                                    </label>
                                                </div>
                                            );
                                        })}
                                    </div>
                                </div>
                            )}
                        </div>

                        {/* Pie del Modal */}
                        <div className="adminModalFooter">
                            <button type="button" className="adminBtnSecondary" onClick={toggleModal} disabled={cargando}>
                                Cancelar
                            </button>
                            <button type="button" onClick={crear} className="adminBtnPrimary" disabled={cargando}>
                                {cargando ? 'Guardando...' : 'Guardar Producto'}
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}
